import { Component, OnInit, Input } from '@angular/core';
import { EmailSmsTemplateModel } from '../shared/models/email-sms-template-model';
import { MessageInnerType } from '../shared/models/message-inner-type.enum';

@Component({
  selector: 'hr-sms-tab-templates-list',
  templateUrl: './sms-tab-templates-list.component.html',
  styleUrls: ['./sms-tab-templates-list.component.less'],
  standalone: false,
})
export class SmsTabTemplatesListComponent implements OnInit {
  private _smsTemplateData: EmailSmsTemplateModel[];

  public smsTemplates: { [innerType: string]: EmailSmsTemplateModel[] };
  public innerTypes: string[];

  public messageInnerTypes = MessageInnerType;
  @Input() set smsTemplateData(smsTemplateData: EmailSmsTemplateModel[]) {
    if (smsTemplateData) {
      this._smsTemplateData = smsTemplateData;

      smsTemplateData.forEach((e) => {
        let innerType = e.messageInnerType;
        if (!this.smsTemplates[innerType]) {
          this.smsTemplates[innerType] = [];
          this.innerTypes.push(this.messageInnerTypes[innerType]);
        }
        this.smsTemplates[innerType].push(e);
      });
    }
  }
  get smsTemplateData(): EmailSmsTemplateModel[] {
    return this._smsTemplateData;
  }

  public isHidden: boolean;
  public smsTemplate: string;
  public smsTemplateTitle: string;

  constructor() {
    this.isHidden = true;
    this.smsTemplates = {};
    this.innerTypes = [];
  }

  ngOnInit() {}

  public onClick(title: string, content: string) {
    if (content != this.smsTemplate && title != this.smsTemplateTitle) {
      this.smsTemplateTitle = title;
      this.smsTemplate = content;
      this.isHidden = this.isHidden ? false : this.isHidden;
    } else {
      this.isHidden = !this.isHidden;
    }
  }

  public onBack() {
    this.isHidden = true;
  }
}
